/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuInputRangeDimensions_filters$ref = any;
export type SbRespRefineMenuFilterDimensions_filters$ref = any;
export type SbRespRefineMenuFilterDimensions_filters = ReadonlyArray<{
    readonly " $fragmentRefs": SbSharedRefineMenuInputRangeDimensions_filters$ref;
    readonly " $refType": SbRespRefineMenuFilterDimensions_filters$ref;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterDimensions_filters",
  "type": "SearchBrowseFilter",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_filters",
      "args": null
    }
  ]
};
(node as any).hash = 'da120dcca3c094f9a082023bad3bbb40';
export default node;
